import * as React from "react";
function SvgTrashBin(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 8h1V6h-4V4a2 2 0 00-2-2H9a2 2 0 00-2 2v2H3v2h1v12a2 2 0 002 2h12a2 2 0 002-2V8zm-2 0H6v12h12V8zM9 6h6V4H9v2zm2 4v8H9v-8h2zm4 8v-8h-2v8h2z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgTrashBin);
export default ForwardRef;
